import { parseLanguageTag, LanguageTag } from '@phensley/language-tag';
import { LanguageResolver } from './resolver';
var UNDEFINED = new LanguageTag();
/**
 * Merged declaration to add a resolve() method to Locale interface.
 *
 * @public
 */
var LocaleResolver = /** @class */ (function () {
    function LocaleResolver() {
    }
    /**
     * Parses a language tag and resolves it, substituting aliases and
     * adding likely subtags.
     */
    LocaleResolver.resolve = function (id) {
        var tag = parseLanguageTag(id);
        if (tag.hasLanguage() || tag.hasScript() || tag.hasRegion()) {
            tag = LanguageResolver.resolve(tag);
        }
        else {
            tag = UNDEFINED;
        }
        return { id: id, tag: tag };
    };
    return LocaleResolver;
}());
export { LocaleResolver };
//# sourceMappingURL=locale.js.map